function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import utils from '@/js/utils';
import { LIST_ROLES, LIST_DOMAINS, ROLES_LIST } from '@/js/constants';
import tasks from '@/js/tasks';
import mlops_service from '@/apps/analytic-services/services/mlops_service';
/*
  |---------------------------------------------------------------------
  | Board Page
  |---------------------------------------------------------------------
  |
  | Kanban board page component with the logic to display and manage
  | cards
  |
  */
export default {
  components: {},
  data: function data() {
    return {
      filter_enabled: true,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dates: [],
      dates2: [],
      solicitudes: [],
      estados: [{
        value: 'REQUESTED',
        text: 'SOLICITADO'
      }, {
        value: 'REJECTED',
        text: 'RECHAZADO'
      }, {
        value: 'APPROVED',
        text: 'APROBADO'
      }],
      types: [{
        value: 'VERTEX_PIPELINE',
        text: 'VERTEX PIPELINE'
      }
      //{ value: 'BIGQUERY', text: 'BIGQUERY' },
      ],
      filters: {},
      solicitudes_to_filters: [],
      key_table: 1,
      pagination: {
        current: 1,
        total: 0,
        sort_by: ['request_date'],
        sort_desc: [true]
      },
      request_code: '',
      response: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('analytic-services', ['has_mlops_active'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    },
    headers: function headers() {
      return [{
        text: this.traductor('tabla_solicitudes.name'),
        value: 'code'
      }, {
        text: 'Pipelines',
        value: 'pipelines'
      }, {
        text: this.traductor('tabla_solicitudes.type'),
        value: 'type',
        align: "center"
      }, {
        text: this.traductor('tabla_solicitudes.status'),
        value: 'status',
        align: "center",
        class: "w-15"
      }, {
        text: this.traductor('tabla_solicitudes.created_date'),
        value: 'request_date',
        align: "center"
      }, {
        text: this.traductor('tabla_solicitudes.user_request'),
        value: 'applicant',
        align: "center"
      }, {
        text: this.traductor('tabla_solicitudes.actions'),
        value: 'acciones',
        align: "left",
        class: "w-15"
      }];
    },
    filtros: function filtros() {
      return {
        name: this.traductor('tabla_solicitudes.name'),
        type: this.traductor('tabla_solicitudes.type'),
        status: this.traductor('tabla_solicitudes.status'),
        rango: this.traductor('filtros.rango')
      };
    },
    getUserEmail: function getUserEmail() {
      return window.userInfo.email;
    },
    dateRangeText: function dateRangeText() {
      return this.filters.fechas ? this.filters.fechas.join(' ~ ') : '';
    },
    isMLSteward: function isMLSteward() {
      return window.userInfo.userRoles.includes(ROLES_LIST.ML_STEWARD);
    }
  }),
  created: function created() {
    if (!this.has_mlops_active) {
      this.$router.push({
        name: 'HomePage'
      });
      return;
    }
    console.log("debug", 'S' + new Date().toISOString().slice(0, 19).replace("T", "").replace(/[-:]/g, "") + '-' + Array.from({
      length: 3
    }, function () {
      return String.fromCharCode(65 + Math.floor(Math.random() * 26));
    }).join(''));
    this.onLimpiar();
  },
  methods: {
    onLimpiarFiltroFecha: function onLimpiarFiltroFecha() {
      this.filters.fechas = [];
      this.menu2 = false;
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    goToCreatePipeline: function goToCreatePipeline() {
      this.$router.push({
        name: "MlOpsCreate"
      });
    },
    onViewRequest: function onViewRequest(item) {
      console.log(item);
      if (item.type == "VERTEX_PIPELINE") {
        this.$router.push({
          name: "MlOpsViewPipeline",
          params: {
            request_id: item.request_id
          }
        });
      }
      if (item.type == "BIGQUERY") {
        this.$router.push({
          name: "MlopsViewResource",
          params: {
            request_id: item.request_id
          }
        });
      }
    },
    onEditRequest: function onEditRequest(item) {
      if (item.type == "VERTEX_PIPELINE") {
        this.$router.push({
          name: "MlOpsEditPipeline",
          params: {
            request_id: item.request_id
          }
        });
      }
      if (item.type == "BIGQUERY") {
        this.$router.push({
          name: "MlopsViewResource",
          params: {
            request_id: item.request_id
          }
        });
      }
    },
    goToCreateBigquery: function goToCreateBigquery() {
      this.$router.push({
        name: "TableCreate"
      });
    },
    openDialogResource: function openDialogResource() {
      //this.$refs["DIALOG_RESOURCE"].onOpen()
      this.goToCreatePipeline();
    },
    formatDateLast: function formatDateLast(data) {
      return data ? data.substring(0, 19).replace("T", " ") : '';
    },
    onLimpiar: function onLimpiar() {
      this.solicitudes = Object.assign([], this.solicitudes_to_filters);
      this.resetFilters();
      this.solicitudes = [];
      this.getSolicitudes();
    },
    resetFilters: function resetFilters() {
      this.filters = {
        type: "VERTEX_PIPELINE",
        status: "REQUESTED"
      };
    },
    getSolicitudes: function getSolicitudes() {
      var _this = this;
      var datos = {
        filters: this.filters
      };
      mlops_service.getRequests(datos).then(function (response) {
        console.log(response);
        _this.solicitudes = response.data;
        _this.solicitudes_to_filters = Object.assign([], response.data);
        _this.key_table += 1;
      });
    },
    onSearch: function onSearch() {
      var _this2 = this;
      this.solicitudes = Object.assign([], this.solicitudes_to_filters);
      if (this.filters.name) {
        this.solicitudes = this.solicitudes.filter(function (x) {
          return x.code && x.code.toUpperCase().indexOf(_this2.filters.name.toUpperCase()) != -1;
        });
      }
      if (this.filters.pipeline) {
        this.solicitudes = this.solicitudes.filter(function (x) {
          return x.pipelines.filter(function (y) {
            return y.name.toUpperCase().indexOf(_this2.filters.pipeline.toUpperCase()) != -1;
          }).length > 0;
        });
      }
      if (this.filters.fechas) {
        if (_typeof(this.filters.fechas) === "object") {
          if (this.filters.fechas.length > 1) {
            this.solicitudes = this.solicitudes.filter(function (x) {
              return x.request_date.substring(0, 10) >= _this2.filters.fechas[0] && x.request_date.substring(0, 10) <= _this2.filters.fechas[1] || x.request_date.substring(0, 10) >= _this2.filters.fechas[1] && x.request_date.substring(0, 10) <= _this2.filters.fechas[0];
            });
          } else if (this.filters.fechas.length == 1) {
            this.solicitudes = this.solicitudes.filter(function (x) {
              return x.request_date.substring(0, 10) >= _this2.filters.fechas[0] && x.request_date.substring(0, 10) <= _this2.filters.fechas[0];
            });
          }
        }
      }
    },
    onConfirmDelete: function onConfirmDelete(event) {
      if (event) {} else {}
    },
    onRejectRequest: function onRejectRequest(item) {
      this.item_selected = item;
      this.response = "";
      this.$refs["MODAL_CONFIRM_REJECT"].onOpen();
    },
    onApproveRequest: function onApproveRequest(item) {
      this.item_selected = item;
      this.response = "";
      this.$refs["MODAL_CONFIRM_APPROVE"].onOpen();
    },
    onCompileRequest: function onCompileRequest(item) {
      this.item_selected = item;
      this.response = "";
      this.$refs["MODAL_CONFIRM_COMPILE"].onOpen();
    },
    onConfirmCompileRequest: function onConfirmCompileRequest(event) {
      var _this3 = this;
      if (event) {
        mlops_service.compileRequest(this.item_selected.id).then(function (response) {
          _this3.$refs["MODAL_CONFIRM_COMPILE"].onClose();
          if (response.success) {
            tasks.toast.success("Se ha compilado el Pipeline, ahora puede ejecutarlo desde la opción 'Componentes'.");
          } else {
            tasks.toast.error("No se ha podido compilar el Pipeline, intentelo en unos minutos.");
          }
        });
      } else {
        this.$refs["MODAL_CONFIRM_COMPILE"].onClose();
      }
    },
    onChangeType: function onChangeType(event) {
      this.getSolicitudes();
    },
    onChangeStatus: function onChangeStatus(event) {
      this.getSolicitudes();
    },
    onConfirmApprove: function onConfirmApprove(event) {
      var _this4 = this;
      if (event) {
        if (!this.response) {
          tasks.toast.error("Debe ingresar una respuesta.");
          return;
        }
        var data = {
          id: this.item_selected.id,
          status: "APPROVED",
          response: this.response
        };
        mlops_service.changeState(data).then(function (response) {
          _this4.item_selected = null;
          _this4.$refs["MODAL_CONFIRM_APPROVE"].onClose();
          if (response.success) {
            tasks.toast.success("La solicitud se ha aprobado correctamente.");
            _this4.getSolicitudes();
          } else {
            tasks.toast.error("No se ha podido aprobar la solicitud.");
          }
        });
      } else {
        this.item_selected = null;
        this.$refs["MODAL_CONFIRM_APPROVE"].onClose();
      }
    },
    onConfirmReject: function onConfirmReject(event) {
      var _this5 = this;
      if (event) {
        if (!this.response) {
          tasks.toast.error("Debe ingresar una respuesta.");
          return;
        }
        var data = {
          id: this.item_selected.id,
          status: "REJECTED",
          response: this.response
        };
        mlops_service.changeState(data).then(function (response) {
          _this5.item_selected = null;
          _this5.$refs["MODAL_CONFIRM_REJECT"].onClose();
          if (response.success) {
            tasks.toast.success("La solicitud se ha rechazado correctamente.");
            _this5.getSolicitudes();
          } else {
            tasks.toast.error("No se ha podido rechazar la solicitud.");
          }
        });
      } else {
        this.item_selected = null;
        this.$refs["MODAL_CONFIRM_REJECT"].onClose();
      }
    }
  }
};